module.exports = __webpack_public_path__ + "static/img/11.9b94aa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/11.jpg
// module id = EBaL
// module chunks = 1